import { Box, VStack } from "@chakra-ui/react"
import AlertsTable from "../components/AlertsTable"
import AlertHeadlines from "../components/AlertHeadlines"
import AlertCreate from "../components/AlertCreate"
import { useAlertsPaginated } from "../hooks/useAlertsPaginated"

function AlertsPaginated() {
  const {
    alerts,
    pagination,
    headlines,
    filterOptions,
    loading,
    error,
    filters,
    sort,
    fetchPage,
    setPageSize,
    setSort,
    setFilters,
    clearAll,
    refetch,
  } = useAlertsPaginated()

  return (
    <VStack gap={0} align="stretch">
      <AlertHeadlines headlines={headlines} loading={loading} />
      <AlertsTable
        alerts={alerts}
        loading={loading}
        error={error ? error.message : undefined}
        onRetry={refetch}
        serverPagination={
          pagination
            ? {
              pagination,
              onPageChange: fetchPage,
              onPageSizeChange: setPageSize,
            }
            : undefined
        }
        serverFiltering={{
          filters,
          sort,
          onFiltersChange: setFilters,
          onSortChange: setSort,
          onClearAll: clearAll,
        }}
        headerActions={<AlertCreate />}
        filterOptions={filterOptions}
      />
    </VStack>
  )
}

export default AlertsPaginated